import { OwaDate } from 'owa-datetime';

/**
 * This enumerates if the instance type is the head, tail or a middle all day instance for an event
 */
export const enum MultiDayEventInstanceType {
    NONE = 0, // this is needed for the all day events which might not need these demaractions
    HEAD,
    MIDDLE,
    TAIL,
}

export default interface MultiDayInfo {
    MultiDayEventInstance: number; // maintains the event instance for a multi-day event
    TotalEventInstances: number; // total number of expansions for a multi-day event
    OriginalEventStart: OwaDate; // maintains the original event start date
    OriginalEventEnd: OwaDate; // maintains the original event end date
    InstanceType: MultiDayEventInstanceType; // this determines which type of instance the current instance is
}
